<template>
  <div class="page-container">
    <RouterView />
  </div>
</template>
